import React from 'react';
import { useLocation, useNavigate } from "react-router";
import bookOverview from '../../../types/BookOverviewType';
import Subtitle from '../../01_atoms/Subtitle/Subtitle';
import Header from '../../02_molecules/Header/Header';
import ReturnIsbn from '../../02_molecules/ReturnIsbn/ReturnIsbn';
import BookDetails from '../../03_organisms/BookDetails/BookDetails';

function AdminDetailPage() {
  const location = useLocation();
  const data = location.state as bookOverview;
  const navigate = useNavigate();

  let isbn = '';
  if (data.isbn) isbn = data.isbn.toString();

  return (
    <div>
      <header>
        <Header
          title="Sweet Bibi"
          buttonLabel="Boek bewerken"
          buttonAction={() => {
            navigate('/admin/edit', { state: data });
          }}
        />
      </header>
      <Subtitle title={data.title} />
      <ReturnIsbn isbn={isbn} />
      <BookDetails data={data} />
    </div>
  );
}

export default AdminDetailPage;
